import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, ArrowUpRight } from "lucide-react";

export default function Resources() {
  const [resources, setResources] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get("/resources").then((r) => setResources(r.data)).catch(() => {});
  }, []);

  const cats = ["All", ...Array.from(new Set(resources.map((r) => r.category)))];
  const filtered = active === "All" ? resources : resources.filter((r) => r.category === active);

  return (
    <div data-testid="resources-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="max-w-2xl">
          <div className="overline">Clinical library</div>
          <h1 className="mt-5 font-heading text-4xl sm:text-5xl leading-tight">Resources for Arizona clinicians</h1>
          <p className="mt-5 text-lg text-[color:var(--azsam-ink-soft)] leading-relaxed">
            Toolkits, coding guides, and evidence reviews created and curated by AzSAM committees for
            practicing addiction specialists and care teams across the state.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="flex flex-wrap gap-2 mb-10" data-testid="resources-tabs">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`resource-tab-${c.replace(/\s+/g, "-").toLowerCase()}`}
              className={`px-5 py-2 rounded-full text-sm font-medium border transition-colors ${
                active === c
                  ? "bg-[color:var(--azsam-sage)] text-white border-[color:var(--azsam-sage)]"
                  : "bg-white text-[color:var(--azsam-ink)] border-[color:var(--azsam-stone)] hover:border-[color:var(--azsam-sage)]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-testid="resources-grid">
          {filtered.map((r) => (
            <a key={r.id} href={r.url || "#"} target="_blank" rel="noreferrer" className="azsam-card p-8 flex gap-5 items-start" data-testid={`resource-${r.id}`}>
              <div className="w-11 h-11 rounded-lg bg-[color:var(--azsam-clay)]/10 text-[color:var(--azsam-clay)] flex items-center justify-center flex-shrink-0">
                <FileText size={20} strokeWidth={1.6} />
              </div>
              <div className="flex-1">
                <div className="overline text-[color:var(--azsam-sage-hover)]">{r.category}</div>
                <h3 className="mt-2 font-heading text-xl leading-snug">{r.title}</h3>
                <p className="mt-3 text-sm text-[color:var(--azsam-ink-soft)] leading-relaxed">{r.summary}</p>
                <div className="mt-5 flex items-center justify-between text-xs text-[color:var(--azsam-ink-soft)]">
                  <span>{r.author}</span>
                  <span className="inline-flex items-center gap-1 text-[color:var(--azsam-clay)] font-semibold">Open <ArrowUpRight size={14} /></span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
